import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { getStorageValues } from '../../shared/CommonFunctions';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import PurchaseRegisterModal from './PurchaseRegisterModal';
import PurchaseRegisterGrid from './PurchaseRegisterGrid';
import { fetchPurchaseRegisterList, savePurchaseRegister, fetchPurchaseRegisterById, deletePurchaseRegister } from '../../utils/purchaseRegisterApi';
import { logAuditEvent } from '../../utils/auditLogger';

function PurchaseRegisterMain(props) {
  const [purchaseRegisters, setPurchaseRegisters] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const [userAction, setUserAction] = useState('Add');
  const [selectedRow, setSelectedRow] = useState(null);
  const moduleName = props.Module || 'Purchase Register';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchPurchaseRegisters();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`);
  }, [moduleName]);

  function openAddModal() {
    setUserAction('Add');
    setSelectedRow(null);
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', `Opened add ${moduleName} modal`);
  }
  async function openEditModal(row) {
    setUserAction('Edit');
    const hydrated = await hydratePurchaseRegister(row);
    setSelectedRow(hydrated);
    setIsOpen(true);
  }
  async function openViewModal(row) {
    setUserAction('View');
    const hydrated = await hydratePurchaseRegister(row);
    setSelectedRow(hydrated);
    setIsOpen(true);
  }
  async function openDeleteModal(row) {
    setUserAction('Delete');
    setSelectedRow(row);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  async function onSubmit(e, data) {
    const actionName = e?.target?.name || (data?.PurchaseRegisterId ? 'Edit' : 'Add');
    const currentUserId = getStorageValues('userId');

    if (actionName === 'Delete') {
      try {
        const payload = {
          PurchaseRegisterId: selectedRow?.PurchaseRegisterId,
          UserId: currentUserId
        };
        const response = await deletePurchaseRegister(payload);
        const spResult = response;
        if (spResult && Number(spResult.success) === 0) {
          CreateAlert(spResult.message || 'Error', 'Error', setAlert);
          return;
        }
        CreateAlert('Purchase Register deleted successfully!!', 'Success', setAlert);
        await fetchPurchaseRegisters();
        closeModal();
      } catch (error) {
        console.log(error);
        CreateAlert('Error deleting purchase register.', 'Error', setAlert);
      }
      return;
    }

    if (!data || !data.DealerId) {
      CreateAlert('Dealer is required!!', 'Warning', setAlert);
      return;
    }

    try {
      const payload = {
        PurchaseRegisterId: data?.PurchaseRegisterId || selectedRow?.PurchaseRegisterId || null,
        DealerId: data.DealerId,
        Remarks: data.Remarks,
        PurchaseDate: data.PurchaseDate,
        PurchaseRegisterDetails: (data.PurchaseRegisterDetails || []).filter((d) => d.Selected),
        UserId: currentUserId
      };
      const response = await savePurchaseRegister(payload);
      const spResult = response;
      if (spResult && Number(spResult.success) === 0) {
        CreateAlert(spResult.message || 'Error', 'Error', setAlert);
        return;
      }
      CreateAlert(spResult?.message || 'Saved', 'Success', setAlert);
      await fetchPurchaseRegisters();
      closeModal();
    } catch (error) {
      console.log(error);
      CreateAlert('Error saving purchase register.', 'Error', setAlert);
    }
  }

  const fetchPurchaseRegisters = async () => {
    try {
      const rows = await fetchPurchaseRegisterList({ userId: getStorageValues('userId') });
      setPurchaseRegisters(rows);
    } catch (error) {
      console.log(error);
    }
  };

  const hydratePurchaseRegister = async (row) => {
    if (!row?.PurchaseRegisterId) return row;
    try {
      const data = await fetchPurchaseRegisterById({ purchaseRegisterId: row.PurchaseRegisterId });
      const header = data?.header || row;
      const details = (data?.details || []).map(d => ({ ...d, Selected: true }));
      return { ...header, PurchaseRegisterDetails: details };
    } catch (err) {
      console.log(err);
      return row;
    }
  };

  const handleExportExcel = () => {
    const columns = [
      { name: "Dealer Name", selector: "DealerName" },
      { name: "Purchase Date", selector: "PurchaseDate" },
    ];
    exportToExcel("PurchaseRegister", columns, purchaseRegisters);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Dealer Name", selector: "DealerName" },
      { name: "Purchase Date", selector: "PurchaseDate" },
    ];
    exportToPDF("PurchaseRegister", columns, purchaseRegisters);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchPurchaseRegisters}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <PurchaseRegisterGrid
        purchaseRegisters={purchaseRegisters}
        onAdd={openAddModal}
        onView={openViewModal}
        onEdit={openEditModal}
        onDelete={openDeleteModal}
        UserPermissions={getUserModulePermission}
        moduleName={moduleName}
      />
      <PurchaseRegisterModal
        show={modalIsOpen}
        UserAction={userAction}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={selectedRow}
        moduleName ={moduleName}
      />
    </>
  )
}

export default PurchaseRegisterMain
